module.exports = __webpack_public_path__ + "img/club-suite.44745124.jpg";